/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsUserPurchaseListItem
 */
export interface IdentityMelcoModelsUserPurchaseListItem {
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    package_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    melco_payment_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    order_reference_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    tax_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    discount_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    total_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    currency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    payout_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    payout_tax_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    payout_discount_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    payout_total_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    payout_currency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    credits_granted?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    type?: number;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    purchase_date?: Date | null;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsUserPurchaseListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
}

export function IdentityMelcoModelsUserPurchaseListItemFromJSON(json: any): IdentityMelcoModelsUserPurchaseListItem {
    return IdentityMelcoModelsUserPurchaseListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsUserPurchaseListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsUserPurchaseListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'package_code': !exists(json, 'package_code') ? undefined : json['package_code'],
        'melco_payment_id': !exists(json, 'melco_payment_id') ? undefined : json['melco_payment_id'],
        'order_reference_id': !exists(json, 'order_reference_id') ? undefined : json['order_reference_id'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'tax_amount': !exists(json, 'tax_amount') ? undefined : json['tax_amount'],
        'discount_amount': !exists(json, 'discount_amount') ? undefined : json['discount_amount'],
        'total_amount': !exists(json, 'total_amount') ? undefined : json['total_amount'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'payout_amount': !exists(json, 'payout_amount') ? undefined : json['payout_amount'],
        'payout_tax_amount': !exists(json, 'payout_tax_amount') ? undefined : json['payout_tax_amount'],
        'payout_discount_amount': !exists(json, 'payout_discount_amount') ? undefined : json['payout_discount_amount'],
        'payout_total_amount': !exists(json, 'payout_total_amount') ? undefined : json['payout_total_amount'],
        'payout_currency': !exists(json, 'payout_currency') ? undefined : json['payout_currency'],
        'credits_granted': !exists(json, 'credits_granted') ? undefined : json['credits_granted'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'purchase_date': !exists(json, 'purchase_date') ? undefined : (json['purchase_date'] === null ? null : new Date(json['purchase_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
    };
}

export function IdentityMelcoModelsUserPurchaseListItemToJSON(value?: IdentityMelcoModelsUserPurchaseListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'product_code': value.product_code,
        'package_code': value.package_code,
        'melco_payment_id': value.melco_payment_id,
        'order_reference_id': value.order_reference_id,
        'amount': value.amount,
        'tax_amount': value.tax_amount,
        'discount_amount': value.discount_amount,
        'total_amount': value.total_amount,
        'currency': value.currency,
        'payout_amount': value.payout_amount,
        'payout_tax_amount': value.payout_tax_amount,
        'payout_discount_amount': value.payout_discount_amount,
        'payout_total_amount': value.payout_total_amount,
        'payout_currency': value.payout_currency,
        'credits_granted': value.credits_granted,
        'type': value.type,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'purchase_date': value.purchase_date === undefined ? undefined : (value.purchase_date === null ? null : value.purchase_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
    };
}


